import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, Input } from 'reactstrap'

import style from '../style'

export const ReplyForm = props => {
  if (!props.ticket || props.ticket.status === 1) {
    return null
  }

  return (
    <form onSubmit={props.onSubmit}>
      <Row>
        <Col>
          <Input
            type='text'
            cols='20'
            rows='4'
            placeholder={`Type message...`}
            name={`message`}
            value={props.editor.message}
            onChange={props.onChange}
            className={css(style.form.input, style.form.textArea)}
          />
        </Col>
        <Col style={{ display: `none` }}>
          <input
            type='submit'
            value='Send'
            className={css(style.form.submit)}
          />
        </Col>
      </Row>
    </form>
  )
}

export default ReplyForm



// WEBPACK FOOTER //
// ./src/components/Support/partials/ReplyForm.js